module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "p-paginator-pages"
  }, _vm._l((_vm.value), function(pageLink) {
    return _c('button', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple"
      }],
      key: pageLink,
      class: ['p-paginator-page p-paginator-element p-link', {
        'p-highlight': ((pageLink - 1) === _vm.page)
      }],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onPageLinkClick($event, pageLink)
        }
      }
    }, [_vm._v(_vm._s(pageLink))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f09cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/paginator/PageLinks.vue
// module id = 2348
// module chunks = 0